import { render } from "./Referral.vue?vue&type=template&id=fa1ef7b6&scoped=true"
import script from "./Referral.vue?vue&type=script&lang=js"
export * from "./Referral.vue?vue&type=script&lang=js"

import "./Referral.vue?vue&type=style&index=0&id=fa1ef7b6&lang=scss&scoped=true"

import exportComponent from "/Users/rantalmor/Desktop/volta-vue/proposal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa1ef7b6"]])

export default __exports__